import type { AllHTMLAttributes } from 'react';

import { BannerPlacement, BannerWrap, BannerBox } from './Banner.styled';

export interface BannerProps extends AllHTMLAttributes<HTMLDivElement> {
  placement?: BannerPlacement;
  show?: boolean;
}

export function Banner({ show, placement = BannerPlacement.topLeft, children }: BannerProps) {
  return (
    <BannerWrap show={show} placement={placement}>
      <BannerBox show={show} placement={placement}>
        {children}
      </BannerBox>
    </BannerWrap>
  );
}
